import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const SmallNavbar = () => {
  const [currentTime, setCurrentTime] = useState(new Date());
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  // Time update
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  // Simple scroll behavior that actually works
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      
      if (currentScrollY < 50) {
        setIsVisible(true);
      } else if (currentScrollY > lastScrollY) {
        // Scrolling down
        setIsVisible(false);
      } else {
        // Scrolling up
        setIsVisible(true);
      }
      
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  const socialLinks = [
    {
      name: 'LinkedIn',
      icon: (
        <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 24 24">
          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
        </svg>
      ),
      href: '#',
      color: 'hover:text-blue-600'
    },
    {
      name: 'Twitter',
      icon: (
        <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 24 24">
          <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
        </svg>
      ),
      href: '#',
      color: 'hover:text-sky-500'
    },
    {
      name: 'Instagram',
      icon: (
        <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 6.62 5.367 11.987 11.988 11.987s11.987-5.367 11.987-11.987C24.014 5.367 18.647.001 12.017.001zM8.449 16.988c-1.297 0-2.448-.596-3.205-1.533l1.714-1.714c.435.435 1.043.708 1.714.708.671 0 1.279-.273 1.714-.708s.708-1.043.708-1.714-.273-1.279-.708-1.714-1.043-.708-1.714-.708c-.671 0-1.279.273-1.714.708L4.244 9.533C5.001 8.596 6.152 8 7.449 8c2.209 0 4 1.791 4 4s-1.791 4-4 4zm8.103 0c-1.297 0-2.448-.596-3.205-1.533l1.714-1.714c.435.435 1.043.708 1.714.708.671 0 1.279-.273 1.714-.708s.708-1.043.708-1.714-.273-1.279-.708-1.714-1.043-.708-1.714-.708c-.671 0-1.279.273-1.714.708l-1.714-1.714C13.104 8.596 14.255 8 15.552 8c2.209 0 4 1.791 4 4s-1.791 4-4 4z"/>
        </svg>
      ),
      href: '#',
      color: 'hover:text-pink-500'
    },
    {
      name: 'GitHub',
      icon: (
        <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
        </svg>
      ),
      href: '#',
      color: 'hover:text-gray-800 dark:hover:text-gray-200'
    }
  ];

  return (
    <div
      className={`fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-blue-600 via-purple-600 to-blue-700 text-white py-2 px-4 text-xs transition-transform duration-300 ease-in-out ${
        isVisible ? 'translate-y-0' : '-translate-y-full'
      }`}
    >
      <div className="container mx-auto flex items-center justify-between">
        {/* Left side - Contact info */}
        <div className="flex items-center space-x-4">
          <motion.div
            className="flex items-center space-x-1"
            whileHover={{ scale: 1.05 }}
          >
            <span className="text-xs">📧</span>
            <span className="hidden sm:inline text-xs">contact@tech4all.in</span>
          </motion.div>
          
          <motion.div
            className="flex items-center space-x-1"
            whileHover={{ scale: 1.05 }}
          >
            <span className="text-xs">📞</span>
            <span className="hidden md:inline text-xs">+91-8056064224</span>
          </motion.div>
        </div>

        {/* Center - Live time */}
        <motion.div
          className="hidden lg:flex items-center space-x-1"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
        >
          <span className="text-xs">🕒</span>
          <span className="font-mono text-xs">
            {currentTime.toLocaleTimeString([], { 
              hour: '2-digit', 
              minute: '2-digit',
              hour12: true 
            })}
          </span>
        </motion.div>

        {/* Right side - Social media and offer */}
        <div className="flex items-center space-x-3">
          {/* <span className="hidden sm:inline text-xs opacity-80">Follow:</span> */}
          {/* <div className="flex items-center space-x-2">
            {socialLinks.map((social, index) => (
              <motion.a
                key={social.name}
                href={social.href}
                className={`transition-colors duration-300 ${social.color} opacity-80 hover:opacity-100`}
                whileHover={{ scale: 1.2 }}
                whileTap={{ scale: 0.9 }}
                title={social.name}
              >
                {social.icon}
              </motion.a>
            ))}
          </div> */}

          {/* Compact offer badge */}
          <motion.div
            className="hidden md:flex items-center bg-white/20 backdrop-blur-sm rounded-full px-2 py-0.5 text-xs"
            whileHover={{ scale: 1.05 }}
          >
            <a href="/contact">
              <span className="mr-1">⭐</span>
              Free Consultation
            </a>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default SmallNavbar;
